export default [
  {
    path: 'member/verify/:token',
    name: 'MemberVerify',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "member-verify" */ '@/modules/auth/views/MemberVerify'
      )
  },
  {
    path: 'auth',
    name: 'AuthenticationCallback',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "auth-callback" */ '@/modules/auth/views/AuthenticationCallback'
      ),
    meta: {
      title: 'Authenticating'
    }
  }
]
